import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import MediaStreamAudioVisualizer from "./MediaStreamAudioVisualizer";

interface MediaStreamAudioProps {}

export interface MediaStreamAudioRef {
  start: () => void;
  stop: () => void;
  getMediaStream: () => MediaStream | null | undefined;
}

const MediaStreamAudio = forwardRef<MediaStreamAudioRef, MediaStreamAudioProps>(
  (_props, ref) => {
    const visualizer = useRef<MediaStreamAudioVisualizer>();

    useEffect(() => {
      const canvas = document.getElementById("visualizer") as HTMLCanvasElement;
      visualizer.current = new MediaStreamAudioVisualizer(canvas);
      visualizer.current.drawInactiveState();
    }, []);

    useImperativeHandle(ref, () => ({
      start: async () => {
        await visualizer.current?.start();
      },
      stop: () => {
        visualizer.current?.stop();
        visualizer.current?.drawInactiveState();
      },
      getMediaStream: () => {
        return visualizer.current?.getMediaStream();
      },
    }));

    return <canvas id="visualizer" className="w-full h-full"></canvas>;
  }
);

export default MediaStreamAudio;
